<template>
  <div class="flex flex-col py-2">
    <div class="w-full py-2">
      <label :for="id" class="block w-full text-lg font-medium">{{label}}</label>
      <input
        @input="$emit('update:value', $event.target.value)"
        :value="value"
        :id="id"
        :class="{ 'border-red-500': error }"
        :type="isPassword ? 'password' : 'text'"
        class="w-full px-2 py-1 border rounded outline-none focus:outline-none"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'textInput',
  props: {
    label: {
      type: String,
      required: true,
    },
    isPassword: {
      type: Boolean,
      required: false,
      default: false,
    },
    id: {
      type: String,
      required: true,
    },
    value: {
      type: String,
      required: true,
    },
    error: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
};
</script>
